// src/profile/profileApi.ts
import { apiClient } from "@maat/api-base";
var profileApi = {
  /** @deprecated Use switchProfile + switchWorkspace instead */
  changeWorkspace: async (data) => {
    return await apiClient.post("/main/api/profile/change", data);
  },
  switchProfile: async (data) => {
    return await apiClient.post("/main/api/profile/switch", data);
  },
  switchWorkspace: async (data) => {
    return await apiClient.post(
      "/main/api/profile/workspace/switch",
      data
    );
  },
  createHostProfile: async () => {
    return await apiClient.post(
      "/main/api/profile/host-profile"
    );
  },
  getMyHostProfile: async () => {
    return await apiClient.get(
      "/main/api/profile/host-profile"
    );
  }
};

export {
  profileApi
};
